import { useState } from "react";

import { cn } from "@/libs/utils";

import { LNB_MENU } from "@/types/lnb";

import CommonImg from "@/components/Common/Img";

import ChevronIconActiveOpen from "@/assets/images/LNB/chevron-icon-active-open.png";
import ChevronIconActiveClose from "@/assets/images/LNB/chevron-icon-active-close.png";
import ChevronIconOpen from "@/assets/images/LNB/chevron-icon-open.png";
import ChevronIconClose from "@/assets/images/LNB/chevron-icon-close.png";

type Props = LNB_MENU & {
  path: string;
  onClick: (path: string) => void;
};
export default function LNBParentButton({
  path,
  id,
  src,
  activeSrc,
  label,
  children,
  onClick,
}: Props) {
  const isSelected = (id: string) => path.startsWith(`/${id}`);
  const isChildSelected = (childId: string) =>
    isSelected(`${id}/${childId.split("/")[0]}`);
  const [open, setOpen] = useState(true);
  return (
    <>
      <div
        className={cn(
          "p-[14px] flex gap-[20px] items-center cursor-pointer text-black",
          {
            "bg-dark-brown text-white rounded-[8px]": isSelected(id),
          }
        )}
        onClick={() =>
          children ? setOpen((prev) => !prev) : onClick(`/${id}`)
        }
      >
        <CommonImg
          src={isSelected(id) ? activeSrc : src}
          alt={`${label} Icon`}
          className="w-[16px] h-[16px]"
        />
        <div className="w-full flex justify-between items-center">
          <span>{label}</span>
          {children && (
            <CommonImg
              src={
                isSelected(id)
                  ? open
                    ? ChevronIconActiveOpen
                    : ChevronIconActiveClose
                  : open
                    ? ChevronIconOpen
                    : ChevronIconClose
              }
              alt="Chevron Icon"
              className={cn({
                "w-[12px] h-[6px]": open,
                "w-[6px] h-[12px]": !open,
              })}
            />
          )}
        </div>
      </div>
      {open && children && (
        <div className="my-[16px]">
          {children.map((child, childIndex) => (
            <div key={childIndex} className="flex gap-[25px]">
              <div className="ml-[16px] w-[2px] bg-gray-C">
                <div
                  className={cn(
                    "w-[8px] h-[8px] bg-gray-C rounded-[8px] relative left-[-3px] top-[22px]",
                    { "bg-dark-brown": isChildSelected(child.id) }
                  )}
                ></div>
              </div>
              <div
                className={cn(
                  "p-[12px] flex gap-[20px] items-center cursor-pointer text-black",
                  {
                    "text-dark-brown": isChildSelected(child.id),
                  }
                )}
                onClick={() => onClick(`/${id}/${child.id}`)}
              >
                <CommonImg
                  src={isChildSelected(child.id) ? child.activeSrc : child.src}
                  alt={`${child.label} Icon`}
                  className="w-[16px] h-[16px]"
                />
                <span>{child.label}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
